// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { BasicEnrollmentSurveyQuestion } from './basicEnrollmentSurveyQuestion.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class BasicEnrollmentSurvey {
    'key': string;
    'questions': Array<BasicEnrollmentSurveyQuestion>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof BasicEnrollmentSurvey>> = [
        {
            "name":     "key",
            "baseName": "key",
            "type":     "string"
        },
        {
            "name":     "questions",
            "baseName": "questions",
            "type":     "Array<BasicEnrollmentSurveyQuestion>"
        },
    ];

    static getAttributeTypeMap() {
        return BasicEnrollmentSurvey.attributeTypeMap;
    }
}
